import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: ' Ngành xây dựng đóng vai trò vô cùng to lớn cùng với sự phát triển của xã hội hiện đại, và theo đó, việc áp dụng công nghệ để nâng cao hiệu quả và an toàn tại công trường xây dựng đang nổi lên như một xu hướng, nhiệm vụ quan trọng. Gần đây, công nghệ Hệ thống định vị thời gian thực (RTLS) đang mang lại những thay đổi mang tính cách mạng tại các công trường xây dựng, và việc áp dụng công nghệ này đóng vai trò quan trọng trong việc xây dựng các công trường xây dựng thông minh.',
  keywords:
    'Quản lý an toàn xây dựng, an toàn xây dựng, xây dựng thông minh, quản lý máy móc thiết bị, quan ly an toan xay dung, an toan xay dung, xay dung thong minh, quan ly may moc thiet bi.',
  ogSite: 'Công trường xây dựng an toàn và thông minh hơn nhờ giải pháp RTLS',
  title: 'Công trường xây dựng an toàn và thông minh hơn nhờ giải pháp RTLS',
  ogUrl: 'https://orbro.io/vi/blog/constructionSafety',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4ODZOuIwgi2GmgeN38XOohY2I6ZhTq1OX26xq5S1gJqAGQsMoshxsOsqKhEqbIAKQ4m2i0wnTaha9gJzWrOTQJjh-kG35v_PKDbGn6oQKyjdPrG83wKwq9aDBoWxLoDMDp5REkLIfvg86TqENuhdkKlvaCE8JtLLjZtoMWuiSQCYZYRXIk1QRwMiLlKrLdUR3Ae7WNDbQamCAEzOhA4iB7NibqGzN1cFrlfeKXbBN95eOv_6gdNvv8egQ9WRKK1ABThUboxhbiTLeGy74mZO217xUHPe9qAWl_BitXQj3yMJXo_3BQUooKtjvw8Lm1OAObOJX5ZUIyV_DF_WDnsYCP6ypezD9GmdGsasbiagdvp9zxbH2CvrIBSLYhNFv34TTAiztM6BukR-0OJInkIZHvaJQyilhLrE44lrqa8M3IzDhzWEOK-bb3Tz5mXAe370UpbaXxkMHaEJS72MZgBbyUj-J3f7J889zkMt7U7UffPNi4BGFhgb5prG4kOatNmsgh8pmVHsAk4xHZ8Fewny7ASDPV2Q4z9YuGgCynJaNDxYwb3FurwZ8G-Nfwgdt2KfslDc1yQ5I-IX-4gd8DTlSCr596Caq2a1UsBSEyl4J9lioE1CFUj22KymcIVvSBhkp285DCyho_1lztbytT6HMUyMOyaMMvEyNnug6qmzJeQEVITT9AqDTwv4crACqyBUCZXmdgcBNa45zkwL_Jsx1akoJohEvzXJ7qMFfZHXmPapV4uS5jSmJGSkvVPCjjhTqGFvy0NDStFwvdrwqGHnI34q1-p2wTpJG2kvUhUH7grFZhik9E7V--QY6HF4fkAjtjgmSiY3mrf4qGOxawVFTvH0n5R4fppcdngOJRnpXyeNUIm-1L8-Qe_A7xZl04bFY7AMwjt9u-DeXWOdd6buaBYjig4EHIovTR2IeuTI2BtFyttqCDwpea3cJuouIq4VZ_m8QEFTUGrq8hkviXmE8iVc80a_vpEfJebHjzWM5f48cjhEk-LVjsrECpYd1lU9TYRV3a6mLY0VxcVpNdN8rxI7cQe5YgRBJGSHR4ECjku3U9jvPJeMJ7hJ4V9D8donENtGVDWuiVPXUk6RH9XU9yeVxMTApzrsB58tA03IPp8f2Aejpzr8ksllmvuubwwbr3JXX6nqREowvgldTiKTGrvT0ca1ol6reTjqX5Xr06c0n5F2v-aYGnPNajdoQNBxtUcxpQRVd-yKyJryJXz56r_J6c2QiiVIADQMjYUH9ULyFT0d0UvnwJS4cTdqEGBzUoJNTLZZi2JtD3cJvG8vrrz5xHUsR2SIkyNjCGLZyOouOh7etxxjVK_MNFYqDGli4SQhp48hMgCc56c4vMuWmZXZlSgUueLUUtEBsLpUFaTERHwqNvJaRHFJOpIyNIOsibD94KowEbCGWg9pydqRNrAdY7TQ7HbAUqUTWFMdCD4Kzkdx4cKPIzL9YTVCvBtk23t0a9E343R1x38JavpVlYeMQVxXxDG5jpP5O9lXmBitXgEfDHBmTnT_BUAvgjYjkUG5djwJfZ6E8K_FRHXtgkB-M62IYcrVsaZAd_9c1Mq8YKMP-fJ=w2052-h1199',
  ogType: 'website',
  date: '2023-09-19',
  tag1: '#Quanlyantoanxaydung',
  tag2: '#Antoanxaydung',
  tag3: '#Xaydungthongminh',
  tag4: '#Quanlymaymocthietbi',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Ngành xây dựng đóng vai trò vô cùng to lớn cùng với sự phát triển của xã hội hiện đại, và theo đó, việc áp dụng công nghệ để nâng cao hiệu quả và an toàn tại công trường xây dựng đang nổi lên như một xu hướng, nhiệm vụ quan trọng. Gần đây, công nghệ Hệ thống định vị thời gian thực (RTLS) đang mang lại những thay đổi mang tính cách mạng tại các công trường xây dựng, và việc áp dụng công nghệ này đóng vai trò quan trọng trong việc xây dựng các công trường xây dựng thông minh. Trong blog này, chúng ta sẽ tìm hiểu về khái niệm công nghệ RTLS và cách thức xây dựng công trường xây dựng thông minh thông qua công nghệ này.',
      dot: '',
    },
    {
      head: 'Khái niệm về Công nghệ RTLS',
      subHead: '',
      desc: 'Hệ thống định vị thời gian thực (RTLS) là công nghệ sử dụng kỹ thuật truyền thông không dây để theo dõi vị trí chính xác của vật thể hoặc đối tượng theo thời gian thực. RTLS sử dụng nhiều công nghệ đa dạng như GPS, RFID (Radio-Frequency Identification), UWB (Ultra-Wideband), BLE (Bluetooth Low Energy), v.v., để thu thập và quản lý thông tin vị trí. Tại công trường xây dựng, có thể ứng dụng các công nghệ này để quản lý và giám sát hiệu quả các trang thiết bị, vật liệu, nhân lực, v.v.',
      dot: '',
    },
    {
      head: 'Lợi ích của Công nghệ RTLS',
      subHead: '',
      desc: 'Việc áp dụng công nghệ RTLS vào công trường xây dựng mang lại nhiều lợi ích như sau.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý tài sản và thiết bị',
      desc: 'Thông qua RTLS, có thể nắm bắt vị trí và tình trạng của thiết bị xây dựng và vật liệu theo thời gian thực, giúp thực hiện quản lý kho và bảo trì một cách hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao an toàn',
      desc: 'Giám sát vị trí của người lao động theo thời gian thực giúp phòng ngừa tai nạn an toàn và cho phép ứng phó nhanh chóng trong tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao năng suất',
      desc: 'Có thể quản lý tiến độ và khối lượng công việc xây dựng để nâng cao năng suất, đồng thời ngăn chặn lãng phí thời gian và nguồn lực quá mức.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích dữ liệu và dự đoán',
      desc: 'RTLS thu thập và phân tích dữ liệu giúp hiểu rõ các mẫu hình công việc xây dựng và hỗ trợ dự đoán trong tương lai. Qua đó, hỗ trợ việc ra quyết định và cho phép phân bổ nguồn lực (resource) hiệu quả.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng RTLS để xây dựng công trường thông minh',
      subHead: 'Vận hành thiết bị tự động hóa',
      desc: 'Vận hành thiết bị tự động hóa bằng RTLS là một trong những ứng dụng cốt lõi giúp nâng cao năng suất và giảm chi phí tại công trường. Gắn thẻ (tag) RTLS vào thiết bị xây dựng cho phép theo dõi vị trí và tình trạng của thiết bị đó theo thời gian thực. Qua đó, người quản lý xây dựng có thể tối ưu hóa lộ trình di chuyển của thiết bị và giảm thiểu tiêu thụ nhiên liệu. Ví dụ, thời gian và năng lượng vận chuyển vật liệu có thể bị lãng phí nếu cần cẩu (crane) không được bố trí hiệu quả. Sử dụng RTLS giúp tối ưu hóa vị trí cần cẩu, rút ​​ngắn thời gian vận chuyển vật liệu và tiết kiệm năng lượng. Hệ thống tự động hóa này thực hiện tiến độ công việc nhanh hơn, nâng cao năng suất, đồng thời giúp tăng hiệu quả sử dụng năng lượng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an toàn cho người lao động',
      desc: 'An toàn của người lao động tại công trường xây dựng là vô cùng quan trọng. Công nghệ RTLS giúp ích rất nhiều trong việc tăng cường an toàn cho người lao động. Người lao động cần phải đeo thẻ (tag) RTLS. Thông qua các thẻ này, có thể theo dõi vị trí của người lao động theo thời gian thực và gửi cảnh báo nếu họ đi vào khu vực nguy hiểm hoặc có khả năng xảy ra tai nạn. Hơn nữa, có thể theo dõi tình trạng sức khỏe của người lao động và nếu phát hiện họ đang làm việc trong môi trường khắc nghiệt, có thể tạm dừng công việc hoặc thực hiện các biện pháp thích hợp. Hệ thống này góp phần phòng ngừa tai nạn và tăng cường an toàn cho người lao động.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý vật liệu và thiết bị',
      desc: 'Quản lý vật liệu và thiết bị là một trong những yếu tố quan trọng quyết định sự thành bại của dự án xây dựng. Sử dụng RTLS cho phép nắm bắt vị trí và tình trạng của vật liệu và thiết bị được sử dụng tại công trường theo thời gian thực. Qua đó, việc quản lý kho hàng có thể được thực hiện hiệu quả hơn và giảm thiểu tổn thất. Ví dụ, có thể ngăn chặn tình trạng thiếu vật liệu cần thiết tại một điểm nào đó hoặc lưu trữ trùng lặp. Hơn nữa, có thể tìm ra các thiết bị đang không hoạt động và tối ưu hóa lịch trình bảo trì.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tối ưu hóa quy trình',
      desc: 'RTLS cũng được sử dụng để tối ưu hóa quy trình xây dựng. Các dự án xây dựng bao gồm nhiều giai đoạn công việc khác nhau, đòi hỏi sự hài hòa và phối hợp giữa các giai đoạn này. Sử dụng RTLS cho phép giám sát và phân tích khối lượng công việc cũng như tiến độ của từng giai đoạn theo thời gian thực. Điều này không chỉ giúp duy trì chất lượng trong khi tuân thủ lịch trình công việc mà còn giúp ngăn chặn tình trạng tắc nghẽn giữa các công việc và tối ưu hóa quy trình.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý môi trường',
      desc: 'Quản lý môi trường đang ngày càng trở thành một vấn đề quan trọng tại các công trường xây dựng hiện đại. Sử dụng RTLS có thể giám sát và quản lý việc sử dụng năng lượng, quản lý chất thải, thay thế thiết bị cũ kỹ, v.v., tại công trường. Qua đó, có thể cải thiện việc xây dựng thân thiện với môi trường và hiệu quả năng lượng, đồng thời góp phần xây dựng một công trường bền vững.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao dịch vụ khách hàng',
      desc: 'Sử dụng RTLS cũng có thể nâng cao dịch vụ khách hàng. Khách hàng mong đợi được theo dõi tiến độ dự án theo thời gian thực và nhận được phản hồi nhanh chóng nếu có vấn đề phát sinh. Bằng cách sử dụng RTLS để cung cấp thông tin minh bạch về tiến độ dự án và ứng phó nhanh chóng khi có sự cố, có thể nâng cao sự hài lòng của khách hàng.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Việc áp dụng công nghệ RTLS giúp ích rất nhiều cho ngành xây dựng trong việc xây dựng công trường thông minh  và đảm bảo hiệu quả cũng như an toàn tốt hơn. Sử dụng công nghệ này, người quản lý công trường có thể quản lý và giám sát tài sản, người lao động, vật liệu, thiết bị, v.v., một cách hiệu quả hơn, đồng thời xây dựng một hệ thống thông minh giúp phân tích dữ liệu và hỗ trợ ra quyết định. Do đó, tương lai của ngành xây dựng sẽ có thể phát triển mạnh cùng với công nghệ RTLS. Việc tích cực áp dụng công nghệ RTLS để tạo ra những công trường xây dựng thông minh  và an toàn hơn là một nhiệm vụ quan trọng.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
